<template>
    <div class="main-content-container  container-fluid ">
        <div class="page-header row no-gutters py-4  mb-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">Dashboard</span>
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-12  col-lg-4 ">
                <w-card size=110>
                    <w-indicator :title="$tc('COMMON.SITE',2)" :chart-data="sitesIndicatorData"
                                 v-loading="isLoading"/>
                </w-card>
                <w-card size=110>
                    <w-indicator :title="$tc('COMMON.SILO',2)" :chart-data="siloIndicatorsData"
                                 v-loading="isLoading"/>
                </w-card>
            </div>
            <div class="col-12  col-lg-8 ">
                <w-card size="100" full-body>
                    <w-map-chart :silos="silos" v-loading="isLoading"/>
                </w-card>
            </div>
        </div>
        <div class="row mb-4">
            <w-card :title="$tc('MONITOR.SILO_DATA',2)" size=100 full-body>
                <!--<w-table-silo :data="sectionWithErros" :events="events" :on-delete-event="onDeleteEvent"
                         v-loading="isLoading"/>
                         -->
                <w-table-silo :data="silos" :events="events" :on-delete-event="onDeleteEvent"
                         v-loading="isLoading"/>
                         
            </w-card>
        </div>
    </div>
</template>

<script>

    import wTable from "../components/common/wTable.vue";
    import wTableSilo from "../components/common/wTableSilo.vue";
    import wCard from "../components/common/wCard.vue";
    import wIndicator from "../components/common/wIndicator.vue";
    import wLeafletMapChart from "../components/common/charts/wLeafletMapChart";
    import api from "../utils/api/api";
    import mutations from "../utils/store/mutations";
    import storeLoader from "../utils/storeLoader";

    export default {
        name: "Monitor",
        components: {
            "w-table": wTable,
            "w-table-silo": wTableSilo,
            "w-card": wCard,
            "w-indicator": wIndicator,
            "w-map-chart": wLeafletMapChart
        },
        data: function () {
            return {
                status: {NO_DATA: "NO_DATA", OK: "OK", WARN: "WARNING", DANGER: "DANGER"},
                intervalInstance: undefined
            }
        },
        computed: {
            sectionWithErros() {
                if (this.sections === undefined) {
                    return []
                }
                return this.sections.filter(value => {
                    return true
                })
            },
            sites() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                return this.$store.state.sites;
            },
            silos() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                return this.$store.state.sites.map(site => {
                    return site.silos;
                }).flat()
            },
            sections() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                let sections = this.$store.state.sites.map(site => {
                    if (site.silos === undefined) {
                        return []
                    }
                    let sectionsInSilo = site.silos.map(silo => {
                        return silo.sections
                    });
                    return sectionsInSilo.flat();
                });
                return sections.flat().filter(value => {
                    if (value === undefined) {
                        console.info("borro una seccion");
                    }
                    return value !== undefined
                });
            },
            sitesIndicatorData() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                return this.countByStatus(this.sites)
            },
            siloIndicatorsData() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                return this.countByStatus(this.silos);
            },
            isLoading() {
                return this.$store.state.isSynchronizing;
            },
            events: function () {
                return this.$store.state.events;
            }
        },
        mounted: function () {

            this.intervalInstance = setInterval(() => {
                storeLoader.load();
            }, 5 * 60 * 1000);
        },
        methods: {

            countByStatus: function (entities) {
                if (entities === undefined) {
                    return []
                }
                let okSites = entities.filter(entity => {
                    return entity.status === 1
                }).length;

                let warningEntity = entities.filter(entity => {
                    return entity.status === 2
                }).length;

                let dangerEntity = entities.filter(entity => {
                    return entity.status === 3
                }).length;

                let noDataEntity = entities.filter(entity => {
                    return entity.status === 0
                }).length;

                return [{
                    status: this.$t("INDICATOR.DANGER"),
                    size: dangerEntity
                }, {
                    status: this.$t("INDICATOR.OK"),
                    size: okSites
                }, {
                    status: this.$t("INDICATOR.WARN"),
                    size: warningEntity
                }, {
                    status: this.$t("INDICATOR.NO_DATA"),
                    size: noDataEntity
                }];
            },
            onDeleteEvent(event) {
                api.deleteEvent(event.eventid).then(() => {
                    this.$store.commit(mutations.DELETE_EVENT, event);
                }).catch(reason => {
                    this.$message.error("Upps.. ocurrio un error al borrar el evento");
                    console.error("Error al borrar un evento", reason);
                });
            }
        },

        beforeDestroy() {
            if (this.intervalInstance) {
                clearInterval(this.intervalInstance);

            }
        },


    }
</script>

<style>
    .el-table__column-filter-trigger i {
        color: #6ac9d7;
        font-weight: bold;
        font-size: 14px;
    }
</style>